import { render } from "./ShowPJ.vue?vue&type=template&id=5a2fdbe2&scoped=true"
import script from "./ShowPJ.vue?vue&type=script&lang=js"
export * from "./ShowPJ.vue?vue&type=script&lang=js"

import "./ShowPJ.vue?vue&type=style&index=0&id=5a2fdbe2&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2fdbe2"]])

export default __exports__